var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21086_45692)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9883 9.05751C11.9883 6.91207 13.7275 5.17285 15.8729 5.17285H31.0758C33.2213 5.17285 34.9605 6.91207 34.9605 9.05751V14.0692H35.3921V17.9539H34.9605V44.1153C34.9605 46.2608 33.2213 48 31.0758 48H15.8729C13.7275 48 11.9883 46.2608 11.9883 44.1153V21.8385H11.5566V18.3855H11.9883V17.0906H11.5566V14.0692H11.9883V9.05751ZM14.2663 10.6162C14.2663 8.94749 15.619 7.59477 17.2877 7.59477H29.6611C31.3297 7.59477 32.6825 8.94749 32.6825 10.6162V42.5567C32.6825 44.2254 31.3297 45.5781 29.6611 45.5781H17.2877C15.619 45.5781 14.2663 44.2254 14.2663 42.5567V10.6162Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9605 19.2607V44.1154C34.9605 46.2608 33.2213 48 31.0759 48H15.8729C13.7275 48 11.9883 46.2608 11.9883 44.1154V27.7135L14.2663 27.15V42.5567C14.2663 44.2254 15.619 45.5781 17.2877 45.5781H29.6611C31.3297 45.5781 32.6825 44.2254 32.6825 42.5567V19.8243L34.9605 19.2607Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2666 10.6161C14.2666 8.94745 15.6193 7.59473 17.288 7.59473H29.6614C31.33 7.59473 32.6828 8.94745 32.6828 10.6161V42.5566C32.6828 44.2253 31.33 45.578 29.6614 45.578H17.288C15.6193 45.578 14.2666 44.2253 14.2666 42.5566V10.6161Z",
    fill: "#F7F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6828 19.8243V42.5567C32.6828 44.2254 31.33 45.5781 29.6614 45.5781H17.288C15.6193 45.5781 14.2666 44.2254 14.2666 42.5567V27.15L32.6828 19.8243Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 -0.290193L29.6646 5.27715L35.7434 5.70074L30.1761 8.17785L29.7525 14.2567L27.2754 8.68933L21.1966 8.26574L26.7639 5.78862L27.1875 -0.290193Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21086_45692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.914062)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.dc4e6fd14442e2b6b1d6ab3aaa6a0232.svg";
export { ForwardRef as ReactComponent };